/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Period_Last_MonthInputs */

const vi_order_period_last_month = /** @type {(inputs: Order_Period_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng trước`)
};

/**

* @param {Order_Period_Last_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_period_last_month = /** @type {((inputs?: Order_Period_Last_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Period_Last_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_period_last_month(inputs)
});